import React, { useEffect, useState } from "react";

const LoadingMoveez = ({
  text,
  circleSize = 280,
  iconWidth = 122.71,
  iconHeight = 123.78,
  isLoadingShow = false,
  isGeneralLoading = false,
}) => {
  const loadingMessages = [
    "Scanning your photos, this may take a minute while we detect all items.",
    "Next step: review the list and add or remove any missed items.",
    "Our AI agent sizes the truck and crew based on the items it finds.",
    "Your estimate is image-based; final billing follows actual on-site work time.",
    "Finish early, you pay less; runs long, it may be slightly more.",
    "Double-check fragile items are well packed.",
    "You can edit item quantities later; accurate counts keep your quote tight.",
    "We'll show you the cost breakdown before you confirm anything.",
    "Please check if any items are prohibited or restricted.",
    "Thanks for waiting; your quote is loading and almost ready.",
  ];

  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    if (!text) {
      const interval = setInterval(() => {
        setMessageIndex((prev) => (prev + 1) % loadingMessages.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [text]);

  const displayText = text ? text : loadingMessages[messageIndex];

  // Circle calculations
  const circleDiameter = circleSize;
  const cx = circleDiameter / 2;
  const cy = circleDiameter / 2;
  const r = circleDiameter / 2 - 25; // 25px padding from edge for stroke

  if (!isLoadingShow) {
    return null;
  }

  return (
    <div
      className={`fixed inset-0 z-[99999999] flex items-center justify-center font-instrument
    ${
      isGeneralLoading
        ? "bg-[#7876A1]/60 backdrop-blur-sm pointer-events-auto"
        : "bg-transparent pointer-events-none"
    }
  `}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <div
        className="flex flex-col items-center justify-center"
        style={{
          width: `${circleDiameter}px`,
          height: `calc(${circleDiameter}px + 15px + 80px)`,
          textAlign: "center",
        }}
      >
        {/* LOADER - FIXED SIZE 265x265 */}
        <div
          className="relative"
          style={{
            width: `${circleDiameter}px`,
            height: `${circleDiameter}px`,
          }}
        >
          <svg
            width={circleDiameter}
            height={circleDiameter}
            viewBox={`0 0 ${circleDiameter} ${circleDiameter}`}
            className="absolute top-0 left-0"
          >
            {/* Background circle */}
            <circle
              cx={cx}
              cy={cy}
              r={r}
              fill="none"
              stroke="#CDCCD7"
              strokeWidth="8"
            />

            {/* First animated circle */}
            <circle
              cx={cx}
              cy={cy}
              r={r}
              fill="none"
              stroke="#4743BF"
              strokeWidth="8"
              strokeLinecap="round"
              strokeDasharray="200 514"
              style={{
                animation: "spin 1.8s linear infinite",
                transformOrigin: `${cx}px ${cy}px`,
              }}
            />

            {/* Second animated circle */}
            <circle
              cx={cx}
              cy={cy}
              r={r}
              fill="none"
              stroke="#4743BF"
              strokeWidth="8"
              strokeLinecap="round"
              strokeDasharray="150 564"
              style={{
                animation: "spinReverse 2.2s linear infinite",
                transformOrigin: `${cx}px ${cy}px`,
              }}
            />
            {/* Logo as SVG image placed exactly at the SVG center */}
            <image
              href="/images/visionLoadingIcon.svg"
              x={cx - iconWidth / 2}
              y={cy - iconHeight / 2}
              width={iconWidth}
              height={iconHeight}
              preserveAspectRatio="xMidYMid meet"
              className="animate-subtle-shake"
              style={{ pointerEvents: "none" }}
            />
          </svg>
        </div>

        {/* Text below loader - fixed spacing */}
        <div
          className="px-6"
          style={{
            marginTop: "15px",
            fontWeight: 600,
            fontSize: "16px",
            color: "#211F59",
            lineHeight: "1.4",
            width: "320px",
            height: "80px",
            display: "flex",
            alignItems: "start",
            justifyContent: "center",
            textAlign: "center",
            overflow: "hidden",
          }}
        >
          {displayText}
        </div>
      </div>

      {/* Animations */}
      <style jsx>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes spinReverse {
          from {
            transform: rotate(360deg);
          }
          to {
            transform: rotate(0deg);
          }
        }

        @keyframes subtle-shake {
          0%,
          100% {
            transform: translateX(0) translateY(0) rotate(0deg);
          }
          12.5% {
            transform: translateX(-4px) translateY(-2px) rotate(-2deg);
          }
          25% {
            transform: translateX(0) translateY(0) rotate(0deg);
          }
          37.5% {
            transform: translateX(4px) translateY(-2px) rotate(2deg);
          }
          50% {
            transform: translateX(0) translateY(0) rotate(0deg);
          }
          62.5% {
            transform: translateX(-3px) translateY(2px) rotate(-1.5deg);
          }
          75% {
            transform: translateX(0) translateY(0) rotate(0deg);
          }
          87.5% {
            transform: translateX(3px) translateY(2px) rotate(1.5deg);
          }
        }

        .animate-subtle-shake {
          transform-box: fill-box;
          transform-origin: center;
          will-change: transform;
          animation: subtle-shake 4s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default LoadingMoveez;
